import React from "react";
import CardClasses from "./Cards.module.css";
import Icon1 from "Assets/Homepage/Cards/card1.png";
import Icon2 from "Assets/Homepage/Cards/card2.svg";
import Icon3 from "Assets/Homepage/Cards/card3.png";

const Card = [
    {
        icon: Icon1,
        Content:
            "Tax return preparation is a complex process that calls for sophisticated assistance and technical knowledge. As tax professionals,we are fully versed in tax law and are prepared to put our experience to work for you.",
        heading: "Individual Taxes",
    },
    {
        icon: Icon2,
        Content:
            "As a business owner, you must be aware of all tax pitfalls. Our team of business planning department will work according to the tax filing requirements and update you the tax information time by time as per your convenience over call.",
        heading: "Business & Tax Advisory Services",
    },
    {
        icon: Icon3,
        Content:
            "Delivering premium quality and comprehensive audit assurance services is one of our highest priorities.",
        heading: "Audit & Assurance",
    },
    {
        icon: Icon3,
        Content:
            "Using the standard tax planning system, our team of professionals will guide you on how to pay less taxes and receive optimal returns",
        heading: "Year-End Tax Planning",
    },
];

function Cards() {
    return (
        <div className={CardClasses["Container"]}>
            <h3> Our Process</h3>
            <p>
                Our Mission is to produce the highest quality work for every
                client ,on every project
            </p>
            <div className={CardClasses["Cards-wrapper"]}>
                <div className={CardClasses["card"]}>
                    <div className="step-container">
                        <div className="circle">01</div>
                        <div className="step-text">Register</div>
                    </div>
                    <ul>
                        <li>Basic Information</li>
                        <li>Upload Documents</li>
                    </ul>
                </div>
                <div className={CardClasses["card"]}>
                    <div
                        className="step-container"
                        style={{ backgroundColor: "rgb(114, 114, 7)" }}>
                        <div className="circle">02</div>
                        <div className="step-text">Review</div>
                    </div>
                    <ul>
                        <li>Check Summary</li>
                        <li>Detailed Explination</li>
                    </ul>
                </div>
                <div className={CardClasses["card"]}>
                    <div
                        className="step-container"
                        style={{ backgroundColor: "green" }}>
                        <div className="circle">03</div>
                        <div className="step-text">Pay</div>
                    </div>
                    <ul>
                        <li>Pay Securely</li>
                        <li>Acknowledge return</li>
                    </ul>
                </div>
            </div>
        </div>
    );
}

export default Cards;
